// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading-dots_loading___YGem","spacer":"loading-dots_spacer__c4Swo","blink":"loading-dots_blink__7LX1C"};